import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AllChinaBuySheetGuide from "../pages/allchinabuy-sheet-guide/page";
import SafetyGuide from "../pages/allchinabuy-sheet-safety/page";
import VsCompetitors from "../pages/allchinabuy-sheet-vs-competitors/page";
import PricingGuide from "../pages/allchinabuy-sheet-pricing/page";
import BeginnersGuide from "../pages/allchinabuy-sheet-beginners/page";
import ShippingGuide from "../pages/allchinabuy-sheet-shipping/page";
import TrendingGuide from "../pages/allchinabuy-sheet-trending/page";
import WholesaleGuide from "../pages/allchinabuy-sheet-wholesale/page";
import QualityGuide from "../pages/allchinabuy-sheet-quality/page";
import UpdatesGuide from "../pages/allchinabuy-sheet-updates/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuy-sheet-guide",
    element: <AllChinaBuySheetGuide />,
  },
  {
    path: "/allchinabuy-sheet-safety",
    element: <SafetyGuide />,
  },
  {
    path: "/allchinabuy-sheet-vs-competitors",
    element: <VsCompetitors />,
  },
  {
    path: "/allchinabuy-sheet-pricing",
    element: <PricingGuide />,
  },
  {
    path: "/allchinabuy-sheet-beginners",
    element: <BeginnersGuide />,
  },
  {
    path: "/allchinabuy-sheet-shipping",
    element: <ShippingGuide />,
  },
  {
    path: "/allchinabuy-sheet-trending",
    element: <TrendingGuide />,
  },
  {
    path: "/allchinabuy-sheet-wholesale",
    element: <WholesaleGuide />,
  },
  {
    path: "/allchinabuy-sheet-quality",
    element: <QualityGuide />,
  },
  {
    path: "/allchinabuy-sheet-updates",
    element: <UpdatesGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;